module.exports = __webpack_public_path__ + "img/cnn-cover.eff59551.png";